import { useMediaQuery } from "react-responsive";

export const Desktop = ({ children }) => {
  // tslint:disable-next-line: no-unsafe-any
  const isDesktop = useMediaQuery({ minWidth: 992 });
  return isDesktop ? children : null;
};
export const Tablet = ({ children }) => {
  // tslint:disable-next-line: no-unsafe-any
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  return isTablet ? children : null;
};
export const Mobile = ({ children }) => {
  // tslint:disable-next-line: no-unsafe-any
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};
export const Default = ({ children, mobile }) => {
  const isNotMobile = useMediaQuery({ minWidth: 768 });
  return isNotMobile ? children : mobile;
};

export const Default2 = ({ children, mobile }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? mobile : children;
};
